import styled from "styled-components"


export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 110;
  pointer-events: none;
  background-color: black
`;

export const Screen = styled.div`
  position: relative;
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
  width: 100%;
  height: 100%;
  margin-top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  overflow: hidden;

  @font-face {
    font-name: alternate_gothic_bold;
    src: url(../../assets/fonts/Alternate-Gothic-No-2-BT.ttf);
  }

  font-family: alternate_gothic_bold;

  img{
    width:80%;
    opacity:0
  }

`;

export const Title = styled.div`
  font-size: 9vw;
  color: #d87a3e;
  margin: 0;
  line-height: 0.8;

  @media (min-width: 600px) {
    font-size: 46px;
  }
`;
